<template>
  <FooterBlock
      class="footer-block--location"
      :title="config.application.title"
  >
    <Skeleton class="mt-6 mx-n4" max-width="480px" />
  </FooterBlock>
</template>

<script setup lang="ts">
const config = useConfig()
</script>

<style scoped lang="scss">
.footer-block--location {
  :deep(ul) {
    margin-top: -3px;
    line-height: 36px;
  }
}
</style>